"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUsername = void 0;
// Usernames can only contain alphanumerics, underscores, and periods.
//
// There cannot be consecutive periods. There must be an alphanumeric/underscore after
// each period.
var bad_words_1 = __importDefault(require("bad-words"));
var REGEX = /^[a-zA-Z0-9_]+(\.[a-zA-Z0-9_]+)*$/;
var filter = new bad_words_1.default();
function isValidUsername(username) {
    return (username.length > 3 && REGEX.test(username) && !filter.isProfane(username));
}
exports.isValidUsername = isValidUsername;
